import { createSlice } from '@reduxjs/toolkit';
import { Service } from 'services/Services';
import { RequestApi } from 'RequestApi';
import { NotificationMessage } from 'components/notification-message/NotificationMessage';
import { setViewingRecord, setProgressingDocument } from 'components/dynamic/dynamic-page/dynamic-page-training-calender/DynamicPageTrainingCalenderSlice';

const initialState = {
  formLoading: false,
  record: null,
  pageInfo: null,
  unid: null,
  startDate: '',
  endDate: '',
  lineUserSetups: null,
};

const trainingCalenderSlice = createSlice({
  name: 'trainingCalender',
  initialState,
  reducers: {
    setPageInfo(state, action) {
      state.pageInfo = action.payload;
    },
    setFormLoading(state, action) {
      state.formLoading = action.payload;
    },
    setRecord(state, action) {
      state.record = action.payload;
    },
    setStartDate(state, action) {
      state.startDate = action.payload;
    },
    setEndDate(state, action) {
      state.endDate = action.payload;
    },
    setLineUserSetups(state, action) {
      state.lineUserSetups = action.payload;
    },
  },
});

const { setPageInfo, setFormLoading } = trainingCalenderSlice.actions;

export const { setRecord, setUnid, setStartDate, setEndDate, setLineUserSetups } = trainingCalenderSlice.actions;

export const initPageInfo =
  ({ informationPage, document }) =>
  async (dispatch) => {
    try {
      dispatch(setFormLoading(true));
      dispatch(setPageInfo(informationPage));

      let url = `${informationPage.url}/index-info?`;
      url += `auth_token=${Service.userToken}`;

      const data = JSON.stringify({
        data_unid: document.unid,
      });

      dispatch(setViewingRecord({ unid: document.unid }));

      RequestApi(url, {
        data,
      })
        .then((res) => {
          if (res.data.status === 'success') {
            dispatch(setRecord(res.data.record));
            dispatch(setLineUserSetups(res.data.line_user_setups));
            if (!document.status) {
              dispatch(setViewingRecord(res.data.record));
            }
          } else {
            NotificationMessage({ message: res.data.msg, status: res.data.status });
          }

          dispatch(setFormLoading(false));
        })
        .catch((err) => {
          console.log(err);
          dispatch(setFormLoading(false));
          NotificationMessage({ message: err.toString(), status: 'error' });
        });
    } catch (ex) {
      dispatch(setFormLoading(false));
      NotificationMessage({ message: ex.toString(), status: 'error' });
    }
  };

export const submitRegister =
  ({ trainingDocNo, record }) =>
  async (dispatch) => {
    try {
      dispatch(setProgressingDocument(true));

      let urlRequest = `/attendance-event-setup/registration?`;
      urlRequest += `auth_token=${Service.userToken}`;
      urlRequest += '&source_type=portal';

      const data = {
        latitude: 0.0,
        longitude: 0.0,
        workflow: 'Yes',
        qr_code: {
          database_name: 'maxxcreationtechnologycoltd',
          document_type: 'Employee Training Event',
          document_no: trainingDocNo,
          url: `${process.env.REACT_APP_SERVER_API_HOST}/api-hcm-web-portal/v1/attendance-event-setup/registration`,
        },
      };

      RequestApi(urlRequest, {
        data,
      })
        .then((res) => {
          if (res.data.status === 'success') {
            const tmpViewvingRecord = { ...record };
            tmpViewvingRecord.attendance_event_attendee = res.data.sub_record;
            dispatch(setViewingRecord(tmpViewvingRecord));
            // const resRecord = res.data.record;
            // const fieldNames = Object.keys(resRecord);
            // const tmpRecord = { ...record };

            // fieldNames.forEach((objFieldName) => {
            //   tmpRecord[objFieldName] = resRecord[objFieldName];
            // });
            // dispatch(setRecord(tmpRecord));
          } else {
            NotificationMessage({ message: res.data.msg, status: res.data.status });
          }
          dispatch(setProgressingDocument(false));
        })
        .catch((err) => {
          dispatch(setProgressingDocument(false));

          NotificationMessage({ message: err.toString(), status: 'error' });
        });
    } catch (ex) {
      dispatch(setProgressingDocument(false));

      NotificationMessage({ message: ex.toString(), status: 'error' });
    }
  };

const trainingCalenderReducer = trainingCalenderSlice.reducer;

export default trainingCalenderReducer;
